import { render, staticRenderFns } from "./VeJwBukaoModal.vue?vue&type=template&id=3928c2ad"
import script from "./VeJwBukaoModal.vue?vue&type=script&lang=js"
export * from "./VeJwBukaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports